<template>
  <div>
    <v-toolbar
      flat
      color="white"
      class="elevation-1"
    >
      <v-toolbar-title>Tipos de entidades</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        label="Buscar"
        single-line
        hide-details
        v-model="filtros.search"
        v-on:keyup.enter="filtrar"
      >
      </v-text-field>
      <v-btn
        color="info"
        fab
        small
        dark
        @click="filtrar()"
      >
        <v-icon>search</v-icon>
      </v-btn>
      <v-btn
        v-if="puedo('alta')"
        class="white--text"
        round
        color="primary"
        @click="crear"
      >
        <v-icon
          dark
          small
          class="mr-2"
        >add</v-icon>
        Nuevo

      </v-btn>
    </v-toolbar>

    <v-data-table
      must-sort
      :headers="headers"
      :items="items"
      :pagination.sync="paginacion"
      :total-items="totalItems"
      :rows-per-page-items="itemsPorPagina"
      :loading="cargando"
      class="elevation-1"
    >
      <v-progress-linear
        v-slot:progress
        color="blue"
        indeterminate
        v-if="cargando"
      ></v-progress-linear>
      <template v-slot:items="props">
        <td class="text-xs-center pa1">{{ props.item.id }}</td>
        <td class="text-xs-left pa1">{{ props.item.nombre }}</td>
        <td class="text-xs-left pa1">{{ props.item.padre ? props.item.padre.nombre : '' }}</td>
        <td class="">
          <v-layout justify-end>
            <v-btn
              icon
              flat
              small
              color="blue-grey"
              class="mx-0"
              v-if="puedo('lectura') || puedo('modif')"
              @click="ver(props.item)"
            >
              <v-icon small>remove_red_eye</v-icon>
            </v-btn>

            <v-btn
              icon
              flat
              small
              color="blue-grey"
              class="mx-0"
              v-if="$puedo('admin_entidades:' + props.item.slug)"
              @click="entidades(props.item)"
            >
              <v-icon small>list_alt</v-icon>
            </v-btn>
            <v-btn
              icon
              flat
              small
              color="blue-grey"
              class="mx-0"
              v-if="puedo('baja')"
              @click="eliminar(props.item)"
            >
              <v-icon small>delete</v-icon>
            </v-btn>
          </v-layout>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script>

import abmListadoMixin from '@/mixins/abmListado'

export default {
  name: 'TipoEntidadesAbmListado',
  mixins: [abmListadoMixin],
  data: () => ({
    headers: [
      {
        text: 'ID',
        align: 'center',
        value: 'id',
        width: '10%'
      },
      { text: 'Nombre', value: 'nombre' },
      { text: 'Padre', value: 'padre_id', sortable: false },
      { text: '', value: 'name', sortable: false, align: 'right', width: '20%' }
    ]
  }),
  methods: {
    entidades (item) {
      this.$router.push({ name: 'entidades:listar', params: { id: item.id, slug: item.slug } })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
